<template>
    <!-- 商户进件 -->
    <div class="merchantList">
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="searchForm" class="demo-form-inline">
                <el-form-item>
                    <el-input
                        size
                        clearable
                        v-model="searchForm.owner_mobile"
                        placeholder="请输入商户手机号"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        size
                        clearable
                        v-model="searchForm.merchant_number"
                        placeholder="请输入商户编号"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        size
                        clearable
                        v-model="searchForm.license_no"
                        placeholder="请输入营业执照"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="searchForm.merchant_type"
                        clearable
                        placeholder="请选择商户类型"
                    >
                        <el-option label="个人商户" value="1"></el-option>
                        <el-option label="企业商户" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select size v-model="searchForm.status" clearable placeholder="请选择审核状态">
                        <el-option label="审核中" value="1"></el-option>
                        <el-option label="正常" value="2"></el-option>
                        <el-option label="冻结" value="3"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item v-if="level ==0 || level == 1">
                    <el-input size clearable v-model="searchForm.phone" placeholder="请输入归属代理账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-date-picker
                        v-model="rangeDate"
                        type="datetimerange"
                        range-separator="至"
                        start-placeholder="申请开始日期"
                        end-placeholder="申请结束日期"
                        value-format="yyyy-MM-dd"
                        @change="pickerChange"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSearch(searchForm)"
                    >查询</el-button>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="addCompanyMerchantNet()"
                    >新增</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <el-table
                :data="marchantList"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <!-- 序号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 商户类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="merchant_type"
                    label="商户类型"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.merchant_type == 1">个体商户</span>
                        <span v-else-if="scope.row.merchant_type == 0" disabled>企业商户</span>
                    </template>
                </el-table-column>
                <!-- 营业执照 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="license_no"
                    label="营业执照"
                    min-width="170"
                ></el-table-column>
                <!-- 商户名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="merchant_name"
                    label="商户名称"
                    min-width="150"
                ></el-table-column>
                <!-- 商户手机号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    label="商户手机号"
                    min-width="120"
                >
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" :content="scope.row.owner_mobile" placement="top">
                            <p>{{ scope.row.owner_mobile | desMobile }}</p>
                        </el-tooltip>
                    </template>
                </el-table-column>
                <!-- 商户状态 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="status_name"
                    label="审核状态"
                    min-width="100"
                >
                </el-table-column>
                <!-- 商户名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="denial_reason"
                    label="详细信息"
                    min-width="200"
                ></el-table-column>
                <!-- 归属代理账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="u_phone"
                    label="归属代理账号"
                    min-width="120"
                    v-if="level ==0 || level == 1"
                >
                  <template slot-scope="scope">
                    <el-tooltip class="item" effect="dark" :content="scope.row.u_phone" placement="top">
                      <p>{{ scope.row.u_phone | desMobile }}</p>
                    </el-tooltip>
                  </template>
                </el-table-column>
                <!-- 申请时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="create_time"
                    label="申请时间"
                    min-width="140"
                ></el-table-column>
                <!-- 审核时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="check_time"
                    label="审核时间"
                    min-width="140"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="180"
                >
                    <template slot-scope="scope">
                      <el-button @click="updateInfo(scope.row)" type="text" size="small">查看详情</el-button>
                        <el-button @click="updatedate(scope.row)" type="text" size="small">修改资料</el-button>
                      <!-- <el-button @click="updateInfo(scope.row)" type="text" size="small" v-if="scope.row.status!==6">查看详情</el-button> -->
                      <!-- <el-button @click="modifyInfo(scope.row)" type="text" size="small" v-if="scope.row.status==6">编辑</el-button> -->
                      <!-- <el-button @click="rateInfo(scope.row)" type="text" size="small" v-if="scope.row.status==2">费率设置</el-button>
                      <el-button @click="bindInfo(scope.row)" type="text" size="small" v-if="scope.row.status==2">绑定终端</el-button> -->
                    </template>
                </el-table-column>
            </el-table>
            <!-- 交易费率 -->
            <user-rate
                v-if="isShowRate"
                :isShowRate="isShowRate"
                @rateClose="handleRateClose"
            ></user-rate>
            <!-- 分页部分 -->
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :page-sizes="[10,20,50,100]"
                :current-page="currentPage"
                :page-size="pageSize"
                :total="total"
                layout="total, sizes, prev, pager, next, jumper"
            ></el-pagination>
        </el-card>
    </div>
</template>
<script>
import userRate from './setMerchantCompanyRate'; //费率组件
export default {
    name: "merchant-net",
    data() {
        return {
            isShowRate: false, //交易费率
            searchForm: {
                owner_mobile:'',
                merchant_number:'',
                license_no:'',
                merchant_type:'',
                status:'',
                phone:'',
                sn: '',
                start_time: '',
                end_time: '',
            },
            rangeDate: '',
            marchantList: [],
            currentPage: 1, //当前页码
            pageSize: 10, //条数
            total: 0,  //总数
            loading: true,
            level: sessionStorage.getItem('level'),
            dialogData: {
                data: {} //当前行的数据
            },
        }
    },
    created() {

    },
    mounted() {
        this.getData({
            page: 1,
            limit: 10
        })
    },
    components: {
        userRate
    },
    methods: {
        onSearch(searchFrom) {
            this.currentPage = 1;
            searchFrom.page = 1;
            this.getData(searchFrom);
        },
        rateInfo() { //费率
            this.isShowRate = true
        },
        handleRateClose() { //关闭费率
            this.isShowRate = false;
        },
        getData(params) { //获取数据
            this.loading = true;
            this.$api.post("merchant_company/getCompanyMerchantList", params, res => {
                let data = res.data;
                this.total = data.count; //总数
                this.marchantList = res.data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        handleCurrentChange(page) { //当前选中页
            this.currentPage = page;
            this.searchForm.page = page;
            this.searchForm.limit = this.pageSize;
            this.getData(this.searchForm);
        },
        handleSizeChange(limit) { //条数
            this.currentPage = 1;
            this.pageSize = limit;
            this.searchForm.page = 1;
            this.searchForm.limit = limit;
            this.getData(this.searchForm);
        },
        modifyInfo(row) { //绑定终端
                            // this.$message({
                            //     type: 'error',
                            //     message: "暂未开放",
                            //     duration: 2000,
                            
                            // });
          this.$router.push({ path: '/companyMerchantNetModify', query: {m_id:row.id} });
        },
        // handleInfo(row) { //详情
        //   this.$router.push({ path: '/companyMerchantNetInfo', query: {license_no: row.license_no,merchant_type: row.merchant_type} });
        // },
        updateInfo(row) { //修改
          this.$router.push({ path: '/companyMerchantNetUpdate', query: {id: row.id} });
        },
        updatedate(row) { //修改
            this.$router.push({ path: '/companyMerchantNetUpdates', query: {id: row.id} });
        },
        addCompanyMerchantNet() { //新增
            this.$router.push({ path: '/companyMerchantNetAdd', query: {} });
        },
        pickerChange(DateArr) { //时间选择器
            this.searchForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.searchForm.end_time = this._.isEmpty(DateArr) ? '' : DateArr[1];
        },
    }
}
</script>

<style scoped lang="scss">
.merchantList {
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
}
</style>